import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { ShareholderCategoryItemModel } from '../../../models/shareholder-category-item.model';
import { ShareholderTypeModel } from '../../../models/shareholder-type.model';
import { StatisticsResource } from '../../../services/resources/statistics.resource';

@Component({
    selector: 'sl-shareholder-categories',
    templateUrl: './shareholder-categories.component.html',
    styleUrls: ['./shareholder-categories.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShareholderCategoriesComponent implements OnInit {
    totalShareholders = 0;
    totalShares = 0;
    items: ShareholderCategoryItemModel[] = [];

    private readonly statisticsResource = inject(StatisticsResource);

    ngOnInit(): void {
        this.statisticsResource.getShareholderTypes().subscribe(r => this.setupItems(r.value));
    }

    private setupItems(serverItems: ShareholderTypeModel[]): void {
        const newItems: ShareholderCategoryItemModel[] = [];
        const names = serverItems.map(c => c.group);
        const distinctGroupNames = [...new Set(names)].sort();

        distinctGroupNames.forEach(g => {
            let groupTotalShares = 0;
            let groupTotalShareholders = 0;
            const children = serverItems
                .filter(c => c.group === g)
                .map(c => {
                    groupTotalShareholders += c.numberOfShareholders;
                    groupTotalShares += c.numberOfShares;

                    return new ShareholderCategoryItemModel({
                        description: c.subGroup,
                        numberOfShareholders: c.numberOfShareholders,
                        numberOfShares: c.numberOfShares
                    });
                });
            this.totalShareholders += groupTotalShareholders;
            this.totalShares += groupTotalShares;

            newItems.push(
                new ShareholderCategoryItemModel({
                    description: g,
                    numberOfShareholders: groupTotalShareholders,
                    numberOfShares: groupTotalShares,
                    children
                })
            );
        });

        this.items = newItems;
    }
}
